import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'itl-desktop-list-item',
  templateUrl: './desktop-list-item.component.html',
  styleUrls: ['./desktop-list-item.component.scss'],
  standalone: false,
})
export class DesktopListItemComponent {
  @Input() selected: boolean;
  @Output() clicked: EventEmitter<null> = new EventEmitter<null>();
}
